// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3vb-6","title":"ClientReferral_title__2Xve1","itemText":"ClientReferral_itemText__3MN-c"};